import * as Sentry from '@sentry/vue'
import Vue from 'vue'
import VueResource from 'vue-resource'
import { getWithDotNotation, hasPermission } from './utils'
import VueTheMask from 'vue-the-mask'
import Toasted from 'vue-toasted'
import store from './store/store'
import VueOffline from 'vue-offline'
import Cookies from 'js-cookie'
import router from './router/router'

import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { formatarObjetoWebParaSentry } from './sentry.ts'

Vue.use(VueOffline)
Vue.use(VueTheMask)
Vue.use(Toasted)
Vue.use(VueResource)

Vue.http.interceptors.push((request, next) => {
  NProgress.start()
  next((response) => {
    NProgress.done()
  })
})
// Inteceptor relacionado ao Cadastro SSO
Vue.http.interceptors.push((request, next) => {
  const tokenJWTRegex = /^Bearer [A-Za-z0-9-_=]+\.[A-Za-z0-9-_=]+\.?[A-Za-z0-9-_.+/=]*$/
  const { cognitoInfo } = store.state.accessData
  const getSolarToken = () => {
    const token = Cookies.get('Authorization') ||
    (store && store.state && store.state.accessData && store.state.accessData.solarInfo && store.state.accessData.solarInfo.authorization)

    if (typeof token === 'string' && token.match(tokenJWTRegex)) {
      return token
    }
    return null
  }
  const tokenSolar = getSolarToken()

  let token

  if (tokenSolar) {
    token = tokenSolar
  } else {
    token = cognitoInfo ? cognitoInfo.accessToken : null
  }

  if (
    request.url.includes('/coletores/pessoal/sso')
  ) {
    request.headers.set('Authorization', token)
  }
  next()
})
// Inteceptor relacionado ao Cadastro de Coletor
Vue.http.interceptors.push((request, next) => {
  const tokenJWTRegex = /^Bearer [A-Za-z0-9-_=]+\.[A-Za-z0-9-_=]+\.?[A-Za-z0-9-_.+/=]*$/
  const { cognitoInfo } = store.state.accessData
  const getSolarToken = () => {
    const token = Cookies.get('Authorization') ||
    (store && store.state && store.state.accessData && store.state.accessData.solarInfo && store.state.accessData.solarInfo.authorization)

    if (typeof token === 'string' && token.match(tokenJWTRegex)) {
      return token
    }
    return null
  }
  const tokenSolar = getSolarToken()
  let token

  if (store.state.accessData.solarInfo) {
    token = tokenSolar
  } else if (cognitoInfo) {
    token = cognitoInfo.accessToken
  } else {
    token = 'Bearer ' + store.state.accessData.regularToken
  }
  if (
    request.url.includes('/coletores') ||
    request.url.includes('/coletor') ||
    request.url.includes('/perfis-de-coletor') ||
    request.url.includes('/locais') ||
    request.url.includes('/renovar-chave-dispositivo') ||
    request.url.includes('/logar-dispositivo') ||
    request.url.includes('/empregados')
  ) {
    request.headers.set('Authorization', token)
  }
  next()
})

// Interceptor relacionado a sincronizacao/marcacao
Vue.http.interceptors.push((request, next) => {
  const tokenColetor = store.state.accessData.coletor.tokenColetor

  if (!tokenColetor) {
    Sentry.captureEvent({
      message: 'Coletor sem token no interceptor',
      contexts: {
        localStorage: {
          web: formatarObjetoWebParaSentry(window.localStorage.getItem('web'))
        }
      }
    })
  }

  const token = 'Bearer ' + tokenColetor

  if (request.url.includes('/infos-extras-marcacoes/audio')) {
    request.headers.set('Content-Type', 'multipart/form-data')
  }
  if (
    request.url.includes('/sincronizacao-web') ||
    request.url.includes('/validacoes-pre-marcacao') ||
    request.url.includes('/marcacao') ||
    request.url.includes('/infos-extras-marcacoes') ||
    request.url.includes('/comprovante') ||
    request.url.includes('/horario-do-local') ||
    request.url.includes('/horario-localizacao') ||
    request.url.includes('/horario-timezone') ||
    request.url.includes('/layout-customizado')
  ) {
    request.headers.set('Authorization', token)
  }
  next()
})

Vue.http.interceptors.push(function (request, next) {
  if (
    request.url.includes('web/login-cognito') ||
    request.url.includes('/api/auth-logout')
  ) {
    request.headers.set('X-PontoTel-Authorization', store.state.accessData.cognitoInfo.accessToken)
    request.headers.set('X-PontoTel-UP', store.state.accessData.cognitoInfo.userPoolId)
    request.headers.set('X-PontoTel-DI', store.state.accessData.cognitoInfo.userPoolWebClientId)
  }
  next()
})

Vue.http.interceptors.push(_ => {
  return response => {
    if (response.status === 403 && response.bodyText === 'Esse ip não está autorizado para fazer requisições') {
      router.push('/acesso-negado')
    }
  }
})

export const mixins = {
  methods: {
    $getterUseState: (useState) => getWithDotNotation(store.state, useState, '/'),
    $dispatchUseState: (useState, payload) => store.dispatch(useState, payload),
    $commitUseState: (useState, payload) => store.commit(useState, payload)
  }
}

Vue.prototype.$hasPermission = hasPermission
Vue.mixin(mixins)
